import { AbstractModel } from '@/models/abstractModel';
import { ITurnoverSelectionStats, ITurnoverSelectionStatsApi } from '@/types/turnoverSelectionStats';

export class TurnoverSelectionStats extends AbstractModel implements ITurnoverSelectionStats {
    public balance: number;
    public betCount: number;
    public displayedCurrencyId: number | null;
    public netPayoutSum: number;
    public oddsAvg: string | null;
    public settledBetCount: number;
    public stakeSum: number;
    public unsettledBetCount: number;
    public userCount: number;

    constructor(data: ITurnoverSelectionStatsApi) {
        super();
        this.betCount = data.bet_count;
        this.settledBetCount = data.settled_bet_count;
        this.unsettledBetCount = data.unsettled_bet_count;
        this.stakeSum = data.stake_sum;
        this.netPayoutSum = data.net_payout_sum;
        this.balance = data.balance;
        this.userCount = data.user_count;
        this.oddsAvg = data.odds_avg;
        this.displayedCurrencyId = data.displayed_currency_id ?? null;
    }
}
